export const PROJECT_STATUS_LABELS: Record<string, string> = {
  ACTIVE: "Active",
  COMPLETED: "Completed",
  DELAYED: "Delayed",
};

export const PROJECT_STATUS_COLORS: Record<string, string> = {
  ACTIVE: "green",
  COMPLETED: "blue",
  DELAYED: "orange",
};
